module.exports = __webpack_public_path__ + "static/media/main-image.93081d2f.png";